export function formatEuroAmount(value) {
  if (value === null || value === undefined) return '';
  const num = typeof value === 'number' ? value : parseFloat(String(value));
  if (!Number.isFinite(num)) return String(value);

  // Match existing UI style (dot decimals), but avoid trailing ".0" and other trailing zeros.
  // Also avoid thousands separators (e.g. 1,000) since the UI historically prints raw numbers.
  return new Intl.NumberFormat('en-US', {
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(num);
}


